import { render, staticRenderFns } from "./DialogEditCatalogueCategory.vue?vue&type=template&id=6328cc63"
import script from "./DialogEditCatalogueCategory.vue?vue&type=script&lang=js"
export * from "./DialogEditCatalogueCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports